<template>
	<div ref="imageSlider" class="relative w-full h-full">
		<TransitionGroup
			enter-from-class="opacity-0"
			leave-to-class="opacity-0"
			enter-active-class="transition-opacity duration-1000 ease-in-out"
			leave-active-class="transition-opacity duration-1000 ease-in-out"
		>
			<slot name="images" :currentIndex="currentIndex"></slot>
		</TransitionGroup>

		<div class="absolute inset-x-0 bottom-0 max-mob:h-1/2 ~h-128/200 bg-gradient-to-b from-brown-800/0 to-brown-800"></div>

		<div class="absolute ~bottom-24/40 ~inset-x-24/40 flex justify-center mob:justify-between items-center gap-x-24">
			<div class="flex ~gap-8/12 max-mob:hidden">
				<slot name="buttons" :next-slide="nextSlide" :prev-slide="prevSlide"></slot>
			</div>
			<div class="~pb-3/5 text-white flex gap-x-8">
				<span class="faux-h3 italic opacity-60">for</span>
				<div ref="imageSliderWords" class="relative inline-block transition-[width] duration-500 ease-in-out w-[var(--width)]">
					<TransitionGroup
						enter-from-class="opacity-0"
						leave-to-class="opacity-0"
						enter-active-class="transition-opacity duration-500 ease-in-out"
						leave-active-class="transition-opacity duration-500 ease-in-out"
					>
						<span
							class="faux-h3 absolute top-0 right-0"
							v-for="(word, index) in props.words"
							:key="word"
							v-show="currentIndex === index"
						>
							{{ word }}
						</span>
					</TransitionGroup>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, nextTick } from 'vue'
import { onResize } from "@js/throttle.js"

const props = defineProps({
	words: {
		type: Array,
		required: true
	}
})

const imageSlider = ref(null)
const imageSliderWords = ref(null)

const currentIndex = ref(0)
const intervalId = ref(null)

const changeSlide = async (forward = true) => {
	if (forward) {
		currentIndex.value = (currentIndex.value + 1) % props.words.length
	} else {
		currentIndex.value = (currentIndex.value - 1 + props.words.length) % props.words.length
	}
	await nextTick();
	calculateTextWidth()
}

const startSlideshow = () => {
	calculateTextWidth()
	intervalId.value = setInterval(() => {
		changeSlide()
	}, 5000) // Change image every 5 seconds
}

const calculateTextWidth = () => {
	if (!imageSliderWords.value) return
	const currentSpan = imageSliderWords.value.querySelector(`span:nth-child(${currentIndex.value + 1})`)
	if (currentSpan) {
		imageSliderWords.value.style.setProperty('--width', `${currentSpan.offsetWidth}px`);
	}
}

const nextSlide = () => {
	changeSlide()
	if (intervalId.value) {
		clearInterval(intervalId.value);
		startSlideshow();
	}
}

const prevSlide = () => {
	changeSlide(false)
	if (intervalId.value) {
		clearInterval(intervalId.value);
		startSlideshow();
	}
}

onMounted(() => {
	startSlideshow()
	onResize(calculateTextWidth);
})

onBeforeUnmount(() => {
	if (intervalId.value) clearInterval(intervalId.value)
})
</script>
